<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('workCentersCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="work-center-workspace"
         [class.work-center-workspace--loading]="isLoading">
      <mat-card class="work-center-panel work-center-panel--detail">
        <div class="work-center-panel__header">
          <div class="work-center-panel__heading">
            <span class="work-center-panel__eyebrow">{{ 'workCentersCatalog.breadcrumb' | translate }}</span>
            <h3>{{ detailTitle }}</h3>
            <p>{{ detailDescription }}</p>
          </div>
          <div class="work-center-panel__actions">
            @if (selectedWorkCenter && isViewMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-primary"
                    *appCanAccess="updateAccess"
                    (click)="startEdit()">
              <mat-icon>edit</mat-icon>
              {{ 'common.update' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-danger"
                    *appCanAccess="deleteAccess"
                    (click)="deleteSelected()">
              <mat-icon>delete_outline</mat-icon>
              {{ 'common.delete' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
            }
            @if (isCreateMode || isEditMode) {
            <button mat-flat-button
                    type="button"
                    class="btn-tone-primary"
                    (click)="save()"
                    [disabled]="isSaving || !canSave">
              <mat-icon>save</mat-icon>
              {{ isCreateMode ? ('common.create' | translate) : ('common.saveChanges' | translate) }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="cancelEdit()"
                    [disabled]="isSaving">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.cancel' | translate }}
            </button>
            }
          </div>
        </div>

        <div class="work-center-panel__body">
          @if (isCreateMode || isEditMode) {
          <div class="work-center-editor">
            <div class="card work-center-editor__section mb-0">
              <div class="card-body">
                <div class="work-center-section-heading">
                  <div class="work-center-section-heading__title">
                    <h4>{{ 'workCentersCatalog.sections.general' | translate }}</h4>
                    <span class="work-center-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                  </div>
                  <p>{{ 'workCentersCatalog.sections.generalDescription' | translate }}</p>
                </div>

                <div class="row g-3">
                  @if (hasMultipleCompanies) {
                  <div class="col-12">
                    <app-company-select [records]="companies" [value]="form.companiesRecordId"
                                        [label]="'workCentersCatalog.fields.company' | translate"
                                        [placeholder]="'workCentersCatalog.fields.company' | translate"
                                        [disabled]="isSaving"
                                        (valueChange)="form.companiesRecordId = $event; onCompanyChange()" />
                  </div>
                  }
                  <div class="col-12 col-lg-8">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCentersCatalog.fields.name' | translate }}</mat-label>
                      <input matInput
                             [(ngModel)]="form.name"
                             [disabled]="isSaving"
                             [placeholder]="'workCentersCatalog.fields.namePlaceholder' | translate">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-4">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCentersCatalog.fields.scopeLevel' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.scopeLevel"
                                  [disabled]="isSaving"
                                  (ngModelChange)="onScopeLevelChange()">
                        @for (scope of scopeOptions; track scope) {
                        <mat-option [value]="scope">{{ ('workCentersCatalog.scopeOptions.' + scope) | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCentersCatalog.fields.description' | translate }}</mat-label>
                      <textarea matInput
                                rows="3"
                                [(ngModel)]="form.description"
                                [disabled]="isSaving"
                                [placeholder]="'workCentersCatalog.fields.descriptionPlaceholder' | translate"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCentersCatalog.fields.address' | translate }}</mat-label>
                      <textarea matInput
                                rows="3"
                                [(ngModel)]="form.address"
                                [disabled]="isSaving"
                                [placeholder]="'workCentersCatalog.fields.addressPlaceholder' | translate"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCentersCatalog.fields.reference' | translate }}</mat-label>
                      <textarea matInput
                                rows="3"
                                [(ngModel)]="form.reference"
                                [disabled]="isSaving"
                                [placeholder]="'workCentersCatalog.fields.referencePlaceholder' | translate"></textarea>
                    </mat-form-field>
                  </div>
                  @if (form.scopeLevel === 'orgUnit') {
                  <div class="col-12">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                    class="work-center-org-unit-field"
                                    [class.work-center-org-unit-field--disabled]="!canSelectOrgUnit">
                      <mat-label>{{ 'workCentersCatalog.fields.orgUnit' | translate }}</mat-label>
                      <input matInput
                             [value]="selectedOrgUnitPath"
                             [placeholder]="canSelectOrgUnit ? ('employeesCatalog.orgUnitPicker.placeholder' | translate) : ''"
                             [disabled]="!canSelectOrgUnit || isSaving"
                             readonly
                             (click)="canSelectOrgUnit && openOrgUnitPicker()">
                      <button mat-icon-button
                              matSuffix
                              type="button"
                              [disabled]="!canSelectOrgUnit || isSaving"
                              (click)="openOrgUnitPicker()">
                        <mat-icon>{{ canSelectOrgUnit ? 'account_tree' : 'lock_outline' }}</mat-icon>
                      </button>
                      <mat-hint>
                        {{ canSelectOrgUnit
                          ? ('employeesCatalog.orgUnitPicker.anyLevelHint' | translate)
                          : ('employeesCatalog.orgUnitPicker.selectCompanyFirstHint' | translate) }}
                      </mat-hint>
                    </mat-form-field>
                  </div>
                  }
                  @if (form.scopeLevel === 'companiesRecord') {
                  <div class="col-12">
                    <div class="work-center-soft-card work-center-soft-card--fit">
                      <span>{{ 'workCentersCatalog.fields.company' | translate }}</span>
                      <strong>{{ getCompanyName(form.companiesRecordId) }}</strong>
                    </div>
                  </div>
                  }
                  @if (form.scopeLevel === 'employee') {
                  <div class="col-12 col-lg-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCentersCatalog.fields.employee' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.employeeId"
                                  [disabled]="isSaving || !form.companiesRecordId"
                                  (ngModelChange)="onEmployeeChange($event)">
                        @for (employee of availableEmployees; track employee.employeeId) {
                        <mat-option [value]="employee.employeeId">{{ employee.fullName || employee.employeeNumber }} · {{ employee.employeeNumber }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="work-center-soft-card work-center-soft-card--fit">
                      <span>{{ 'workCentersCatalog.fields.orgUnit' | translate }}</span>
                      <strong>{{ selectedOrgUnitName }}</strong>
                    </div>
                  </div>
                  }
                  @if (isEditMode) {
                  <div class="col-12">
                    <div class="work-center-toggle-card">
                      <div>
                        <strong>{{ 'workCentersCatalog.fields.status' | translate }}</strong>
                        <p>{{ 'workCentersCatalog.fields.statusHint' | translate }}</p>
                      </div>
                      <mat-slide-toggle [(ngModel)]="form.isActive"
                                        [disabled]="isSaving"></mat-slide-toggle>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>

            <div class="card work-center-editor__section mb-0">
              <div class="card-body">
                <div class="work-center-section-heading">
                  <div class="work-center-section-heading__title">
                    <h4>{{ 'workCentersCatalog.sections.zones' | translate }}</h4>
                  </div>
                  <p>{{ 'workCentersCatalog.sections.zonesDescription' | translate }}</p>
                </div>

                <div class="row g-3">
                  <div class="col-12 col-lg-12">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCentersCatalog.fields.allowedZones' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.allowedZoneIds"
                                  [disabled]="isSaving || !form.companiesRecordId"
                                  multiple>
                        @for (zone of zones; track zone.zoneId) {
                        <mat-option [value]="zone.zoneId">{{ zone.name }}</mat-option>
                        }
                      </mat-select>
                      <mat-hint>{{ 'workCentersCatalog.fields.allowedZonesHint' | translate }}</mat-hint>
                    </mat-form-field>
                  </div>
                  <!-- <div class="col-12 col-lg-4">
                    <button mat-stroked-button
                            type="button"
                            class="btn-tone-primary work-center-zone-picker-launch"
                            [disabled]="isSaving || !form.companiesRecordId"
                            (click)="openZonePicker()">
                      <mat-icon>add_location_alt</mat-icon>
                      {{ 'workCentersCatalog.actions.addZone' | translate }}
                    </button>
                  </div> -->
                </div>
              </div>
            </div>

            <div class="card work-center-editor__section mb-0">
              <div class="card-body">
                <div class="work-center-section-heading">
                  <div class="work-center-section-heading__title">
                    <h4>{{ 'workCentersCatalog.sections.rules' | translate }}</h4>
                  </div>
                  <p>{{ 'workCentersCatalog.sections.rulesDescription' | translate }}</p>
                </div>

                <div class="row g-3">
                  @for (option of configOptions; track option.key) {
                  <div class="col-12 col-lg-6">
                    <div class="work-center-toggle-card work-center-toggle-card--rule">
                      <div>
                        <strong>{{ option.titleKey | translate }}</strong>
                        <p>{{ option.hintKey | translate }}</p>
                      </div>
                      <mat-slide-toggle [(ngModel)]="form.config[option.key]"
                                        [disabled]="isSaving"></mat-slide-toggle>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          } @else if (selectedWorkCenter; as workCenter) {
          <div class="work-center-detail">
            <div class="card work-center-detail__summary mb-0">
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-6 col-xl-3">
                    <div class="work-center-metric-card">
                      <span>{{ 'workCentersCatalog.fields.scopeLevel' | translate }}</span>
                      <strong>{{ workCenter.scopeLevelLabel }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="work-center-metric-card">
                      <span>{{ 'workCentersCatalog.fields.scopeTarget' | translate }}</span>
                      <strong>{{ workCenter.scopeTargetLabel }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="work-center-metric-card">
                      <span>{{ 'workCentersCatalog.fields.allowedZones' | translate }}</span>
                      <strong>{{ workCenter.zonesSummaryLabel }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="work-center-metric-card">
                      <span>{{ 'workCentersCatalog.fields.status' | translate }}</span>
                      <strong>{{ workCenter.activeLabel }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card work-center-detail__section-card mb-0">
              <div class="card-body">
                <div class="work-center-section-heading">
                  <h4>{{ 'workCentersCatalog.sections.configuration' | translate }}</h4>
                  <p>{{ 'workCentersCatalog.sections.configurationDescription' | translate }}</p>
                </div>
                <div class="row g-3">
                  <div class="col-md-6">
                    <div class="work-center-soft-card"><span>{{ 'workCentersCatalog.fields.company' | translate }}</span><strong>{{ getCompanyName(workCenter.companiesRecordId) }}</strong></div>
                  </div>
                  <div class="col-md-6">
                    <div class="work-center-soft-card"><span>{{ 'workCentersCatalog.fields.name' | translate }}</span><strong>{{ workCenter.name }}</strong></div>
                  </div>
                  <div class="col-md-6">
                    <div class="work-center-soft-card"><span>{{ 'workCentersCatalog.fields.address' | translate }}</span><strong>{{ workCenter.address || '-' }}</strong></div>
                  </div>
                  <div class="col-md-6">
                    <div class="work-center-soft-card"><span>{{ 'workCentersCatalog.fields.reference' | translate }}</span><strong>{{ workCenter.reference || '-' }}</strong></div>
                  </div>
                  <div class="col-12">
                    <div class="work-center-soft-card"><span>{{ 'workCentersCatalog.fields.description' | translate }}</span><strong>{{ workCenter.description || '-' }}</strong></div>
                  </div>
                  <div class="col-12">
                    <div class="work-center-soft-card"><span>{{ 'workCentersCatalog.fields.allowedZones' | translate }}</span><strong>{{ getZoneLabels(workCenter.allowedZoneIds) }}</strong></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card work-center-detail__section-card mb-0">
              <div class="card-body">
                <div class="work-center-section-heading">
                  <h4>{{ 'workCentersCatalog.sections.rules' | translate }}</h4>
                  <p>{{ 'workCentersCatalog.sections.rulesDescription' | translate }}</p>
                </div>
                <div class="row g-3">
                  @for (option of configOptions; track option.key) {
                  <div class="col-12 col-lg-6">
                    <div class="work-center-soft-card work-center-soft-card--rule">
                      <span>{{ option.titleKey | translate }}</span>
                      <strong>{{ getBooleanLabel(workCenter.config[option.key]) }}</strong>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          } @else {
          <div class="work-center-empty">
            <mat-icon>location_city</mat-icon>
            <h4>{{ 'workCentersCatalog.emptyEditorTitle' | translate }}</h4>
            <p>{{ 'workCentersCatalog.emptyEditorDescription' | translate }}</p>
          </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
      <app-loading-state class="work-center-loading"
                         [message]="'workCentersCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
